(function ($) {
    /**
     * Innovation Page Revealer
     * Specifically handles the background blur and counter entrance
     */
    function buildInnovationReveal(el) {
      const servicesInner = el.querySelector(".services-container");
      const counterWrapper = el.querySelector(".slide-counter .current-slide");
      
      const tl = gsap.timeline({ paused: true });

      // 1. Blur In
      tl.to(servicesInner, {
        filter: "blur(0px)",
        duration: 2,
        ease: "power2.out"
      });

      // 2. Counter Mask Slide Up (100ms wait)
      tl.to(counterWrapper, {
        yPercent: 0,
        duration: 0.5,
        ease: "power2.out"
      }, "-=0.5");

      return tl;
    }

    /**
     * Card Reveal
     * Staggered text mask-slide-up for cards
     */
    function revealInnovationCard(card, tl, offset = 0) {
      if (!card) return;
      const title = card.querySelector(".innovation-card-title");
      const desc = card.querySelector(".innovation-card-description");
      
      if (title?._splitText) {
        tl.fromTo(title._splitText.lines, 
          { yPercent: 100 },
          { yPercent: 0, duration: 0.5, ease: "power1.out" },
          offset
        );
      }

      if (desc?._splitText) {
        const lines = desc._splitText.lines;
        tl.fromTo(lines, 
          { yPercent: 100 },
          { 
            yPercent: 0, 
            duration: 0.1 * lines.length + 0.5,
            stagger: 0.1, 
            ease: "power2.out" 
          }, 
          title?._splitText ? ">0.1" : offset
        );
      }
    }

    /**
     * Card Reset
     * Instant reset to hidden state
     */
    function resetInnovationCard(card, tl, offset = 0) {
      if (!card) return;
      const title = card.querySelector(".innovation-card-title");
      const desc = card.querySelector(".innovation-card-description");
      const lines = [];
      if (title?._splitText) lines.push(...title._splitText.lines);
      if (desc?._splitText) lines.push(...desc._splitText.lines);
      
      if (lines.length) {
        if (tl) {
          tl.set(lines, { yPercent: 100 }, offset);
        } else {
          gsap.set(lines, { yPercent: 100 });
        }
      }
    }

    // ─────────────────────────────────────────────────────────────────────────
    // SLIDE ANIMATION REGISTRY
    // ─────────────────────────────────────────────────────────────────────────
    const slideAnimations = [
      {
        triggerOnStart: true,
        onInit: (el) => {
          const servicesInner = el.querySelector(".services-container");
          const counterWrapper = el.querySelector(".slide-counter .current-slide");
          const firstNum = counterWrapper ? counterWrapper.querySelector(".slide-number") : null;
          
          if (firstNum) {
            gsap.set(counterWrapper, { height: firstNum.offsetHeight });
          }
          if (servicesInner) {
            gsap.set(servicesInner, { filter: "blur(16px)" });
          }
          if (counterWrapper) {
            gsap.set(counterWrapper, { yPercent: 100 });
          }

          // Pre-mask service cards content
          const cards = el.querySelectorAll(".innovation-service");
          cards.forEach((card) => {
            const title = card.querySelector(".innovation-card-title");
            const desc = card.querySelector(".innovation-card-description");
            
            if (title && !title._splitText) {
              title._splitText = new SplitText(title, { type: "lines" });
              $(title._splitText.lines).wrap('<div style="overflow: hidden; display: block;"></div>');
              gsap.set(title._splitText.lines, { yPercent: 100 });
            }
            if (desc && !desc._splitText) {
              desc._splitText = new SplitText(desc, { type: "lines" });
              $(desc._splitText.lines).wrap('<div style="overflow: hidden; display: block;"></div>');
              gsap.set(desc._splitText.lines, { yPercent: 100 });
            }
          });
        },
        onEnter: (el, direction, state) => {
          if (!state.hasPlayed) {
            const tl = buildInnovationReveal(el);
            if (tl) tl.play();
            state.hasPlayed = true;
          }
        },
        onLocked: (el, direction, state) => {
          const cards = el.querySelectorAll(".innovation-service");
          const card = cards[state.subSlideIndex];
          if (card) {
            const tl = gsap.timeline();
            revealInnovationCard(card, tl, 0.1);
          }
        },
        // We'll let the library handle the taping loop
        subSlides: {
          selector: ".innovation-service",
          tape: true,
          wrapperSelector: ".services-container",
          onSetTape: (el, subIdx, prevIdx, animate, tl) => {
            const slideNumbers = el.querySelectorAll(".slide-counter .slide-number");
            const cards = el.querySelectorAll(".innovation-service");
            if (!slideNumbers.length) return;
            const h = slideNumbers[0].offsetHeight;

            if (!animate) {
              gsap.set(slideNumbers, { y: -subIdx * h });
              cards.forEach((card, i) => {
                resetInnovationCard(card, null, 0);
              });
              return;
            }

            // 1. Counter Odometer
            tl.to(slideNumbers, { y: -subIdx * h, duration: 0.9, ease: "power2.inOut" }, 0);

            // 2. Card transitions
            if (prevIdx !== -1 && prevIdx !== subIdx) {
              resetInnovationCard(cards[prevIdx], tl, 0.9);
            }
            revealInnovationCard(cards[subIdx], tl, 1.0);
          },
        },
      }
    ];

    // Initialize the library
    window.pageSnaps.init({
      slideAnimations: slideAnimations,
      snapDuration: 0.9,
      hasHero: true,
      hasFooterSnap: true
    });

})(jQuery);
